/** Request timeout in milliseconds. */
export const REQUEST_TIMEOUT_MS = 15000;

/** Default Authorization header prefix (e.g. "Bearer" or "carrum"). Override with REACT_APP_AUTH_PREFIX. */
export const DEFAULT_AUTH_PREFIX = process.env.REACT_APP_AUTH_PREFIX || "bearer";

/** Max number of 401 retries (refresh + one retry of original request). */
export const MAX_401_RETRIES = 1;

/** Max length of response payload sent to Sentry (avoids large payloads / quota). */
export const SENTRY_PAYLOAD_MAX_LENGTH = 10000;
